/**
 * @项目名称: openMainPageTab
 * @功能名称: 跳到原生页
 * @文件名称: openMainPageTab
 * @params: main member explore me market
 * @Date: 2019/1/28
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import xyJsBridge from './xyJsBridge'
export default function (name) {
  name = name || "main"
  var data = {tab:name}
  return xyJsBridge('jsbridge://www.xiaoying.com/app/operation/openMainPageTab',data)
}

